import { getOrigin } from "owa-url/lib/getOrigin";

export function isOriginUrl(url: string): boolean {
    const originUrl = getOrigin().toLowerCase();
    return url.toLowerCase() == originUrl || url.toLowerCase() == originUrl + "/";
}
